import styled from "styled-components"
import { Text } from "../elements/Text"

interface ILabelProps {
  children: React.ReactNode
  required?: boolean
}

const StyledLabel = styled.label`
  width: 100%;
  font-size: clamp(0.75rem, 0.725rem + 0.125vw, 0.875rem);
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 140%;
`

const Label = (props: ILabelProps) => {
  const { children, required } = props
  return (
    <StyledLabel>
      {children}
      {required && <Text primary>*</Text>}
    </StyledLabel>
  )
}

export { Label }
